import { clients } from 'lib/https';
import { ConfigurationSettings } from '/models/configuration-settings';

export interface CaptchaConfig {
  key: string;
  provider: string;
  generator: string;
}

export interface OidcUiConfigResponse {
  captcha: CaptchaConfig | null;
}

export const getOidcUiConfig = async (
  config: ConfigurationSettings,
  tenantId: string
): Promise<OidcUiConfigResponse> => {
  const baseUrl = `https://${config.paths.baseUrl}`;
  const url = `${baseUrl}${config.paths.iam.oidcUiConfig}?tenantId=${tenantId}`;
  
  return clients.get(url, config.blocksKey);
};
